module.exports = __webpack_public_path__ + "img/01.500b9ae9.jpg";